import { render } from "./NotFoundPage.vue?vue&type=template&id=3177e246&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=3177e246&scoped=true&lang=css"
import "./NotFoundPage.vue?vue&type=style&index=1&id=3177e246&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3177e246"]])

export default __exports__